import fetchIntercept from "fetch-intercept";
import { AnyAction, CombinedState, Store } from "redux";
import { FORBIDDEN } from "http-status-codes";
import { AppState } from "store/rootReducer";
import authorizationConstants from "store/features/authorization/authorization.constants";

// eslint-disable-next-line
export const registerInterceptors = (store: Store<CombinedState<AppState>, AnyAction> & { dispatch: unknown }) =>
    fetchIntercept.register({
        request: (url: string, config: RequestInit) => {
            return [url, config];
        },

        requestError: (error) => {
            // Called when an error occurred during another 'request' interceptor call
            return Promise.reject(error);
        },

        response: (response) => {
            if (response.status === FORBIDDEN) {
                store.dispatch({ type: authorizationConstants.AUTHORIZE_FAILED });
            }
            return response;
        },

        responseError: (error) => {
            return Promise.reject(error);
        },
    });
